/**
 * DEV-3454 — resolve a vehicle's battery percent, preferring live telemetry.
 *
 * The Station page populates the `vehicles` REST slice only at page load, so
 * `vehicle.batteryLevel` (camelCase, from the DRF serializer) goes stale. The
 * per-vehicle state WS streams the live value as `battery_level` (snake_case —
 * the raw WS state dict is NOT run through the DRF CamelCase renderer). This
 * helper returns the live value when present and numeric, otherwise the stale
 * REST value (or 0).
 *
 * The WS state is keyed by the no-dashes hex form of the vehicle id, while the
 * `vehicles` slice uses the dashed UUID — so we try both, mirroring the
 * existing live lat/long override in useInProgressVehicles.
 */
export const resolveLiveBattery = (
  vehicleId: string | undefined,
  staleBatteryLevel: number | null | undefined,
  vehiclesUpdateData: VehiclesStateDataItem | null | undefined
): number => {
  const fallback = staleBatteryLevel ?? 0;
  if (!vehicleId || !vehiclesUpdateData) return fallback;

  const dashedId = vehicleId;
  const noDashId = dashedId.replace(/-/g, "");
  const liveState =
    vehiclesUpdateData[noDashId] || vehiclesUpdateData[dashedId];

  if (liveState && typeof liveState.battery_level === "number") {
    return liveState.battery_level;
  }
  return fallback;
};
